<style></style>
<template>
  <v-card class="ma-0 pa-0" v-if="isCategoriesRetrievied">
          <v-card-title>
            <v-text-field
              v-model="objetSearch"
              append-icon="search"
              label="Rechercher parmi ces objets"
              single-line
              hide-details clearable
            ></v-text-field>
          </v-card-title>
        <v-data-table
          :headers="computedHeaders"
          :search="objetSearch"
          :items="objectsGeoJson"
          sort-by="id"
          :disable-sort="$vuetify.breakpoint.xsOnly"
          :hide-default-header="$vuetify.breakpoint.xsOnly"
          class="elevation-1"
          @click:row="handleClickItemRow"
        >
          <template v-slot:top>
            <v-toolbar flat color="white" class="hidden-sm-and-down">
              <v-toolbar-title>Liste des {{ subject }}s</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:item.properties.title="{ item }">
            <div
                 :class="[
                   {'font-weight-bold': item.properties.isurgent},
                   {'green--text': item.properties.isvalidated},
                   {'orange--text': !item.properties.isvalidated},
                  ]"
                 dark>
              {{item.properties.isurgent ? 'URGENT :' : ''}}
              {{ item.properties.title | limitTextSize }}

            </div>
          </template>
          <template v-slot:item.properties.idcategorie="{ item }">
            <v-chip :color="item.properties.isvalidated ? 'green': 'orange'" dark>
              {{ getCategoryName(item.properties.idcategorie) }}
            </v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon  class="mr-2"
                     v-if="checkEditPermissions(item)"
                     @click="editItem(item)">
              {{mdiPencil}}
            </v-icon>
            <v-icon  class="mr-2" v-if="item.properties.isvalidated!=null
            || !checkEditPermissions(item)"
                     @click="showItem(item)">
              visibility
            </v-icon>
            <v-icon color="green" title="VALIDER cette dégradation"
                    v-if="checkValidatePermissions(item)"
                    @click="validateItem(item)" >
              {{mdiCheck}}
            </v-icon>
            <v-icon color="red" title="REFUSER cette dégradation"
                    v-if="checkValidatePermissions(item)"
                    @click="unValidateItem(item)" >
              {{ mdiClose }}
            </v-icon>
            <v-icon color="orange" title="TERMINER cette dégradation"
                    v-if="checkTerminatePermissions(item)"
                    @click="terminateItem(item)" >
              archive
            </v-icon>
            <v-icon color="red" title="EFFACER cette dégradation"
                    @click="deleteItem(item)"
                    v-if="isUserAdmin && item.properties.idcategorie > 1
                     && item.properties.idcategorie < 1001">
              {{mdiDelete}}
            </v-icon>
          </template>
          <template v-slot:no-data>
            <v-subheader>AUCUNE DEGRADATION TROUVEE !</v-subheader>
          </template>
        </v-data-table>
        </v-card>
</template>

<script>
import {
  mdiCheck, mdiClose, mdiDelete, mdiPencil,
} from '@mdi/js';
import { dateIso2Fr, isNullOrUndefined } from 'cgil-html-utils';
import { DEV, getLog } from '../config';
import degradationCategories from './DegradationCategories';
import DegradationMixin from './Degradation_mixin';
import {
  getUserIsAdmin,
  getUserIsValidator,
  getUserId,
  isUserHavingLimitedCategories,
  getUserLimitedCategoriesArray,
} from './Login';

const MODULE_NAME = 'DegradationManager';
const log = getLog(MODULE_NAME, 4, 2);
const convertEnt = (text) => {
  if (isNullOrUndefined(text)) return '';
  let textFiltered = `${text}`.trim();
  textFiltered = textFiltered.replace(/&#39;/g, '\'');
  textFiltered = (`${text}`).replace(/&#\d+;/gm, (s) => String.fromCharCode(
    s.match(/\d+/gm)[0],
  ));
  return textFiltered;
};
export default {
  name: 'DegradationManager',
  mixins: [DegradationMixin],
  props: {
    objectsGeoJson: { type: Array },
  },
  data: () => ({
    isInDev: DEV,
    isUserAdmin: false,
    isUserValidator: false,
    idUser: null,
    headers: [
      {
        text: 'Id',
        value: 'properties.id',
        hide: 'mdAndDown',
      },
      {
        text: 'Titre',
        value: 'properties.title',
        align: 'start',
        width: '60%',
        class: 'hidden-sm-and-down',
      },
      {
        text: 'Categorie',
        value: 'properties.idcategorie',
        hide: 'smAndDown',
        width: '1%',
      },
      /* {
        text: 'Validée ?',
        value: 'properties.isvalidated',
        hide: 'lgAndDown',
        width: '1%',
      }, */
      {
        text: 'Actions',
        value: 'actions',
        align: 'right',
        width: '30%',
        sortable: false,
        class: 'hidden-sm-and-down',
      },
    ],
    categories: [],
    isCategoriesRetrievied: false,
    mdiCheck,
    mdiClose,
    mdiDelete,
    mdiPencil,
  }),
  created() {
    log.t(`# ${MODULE_NAME} created()`);
    degradationCategories.getCategorieList((data, errMessage) => {
      if (!isNullOrUndefined(data)) {
        this.categories = data;
        log.l('# IN degradationCategories -> categories :', this.categories);
        this.isCategoriesRetrievied = true;
      } else {
        log.e(
          `# GOT ERROR IN initialize() in callback for degradationCategories.getCategorieList data: ${errMessage}`,
        );
        this.isCategoriesRetrievied = false;
      }
    });
  }, // end of created
  mounted() {
    log.t(`# ${MODULE_NAME} mounted()`);
    this.isUserAdmin = getUserIsAdmin();
    this.isUserValidator = getUserIsValidator();
    this.idUser = getUserId();
  }, // end of mounted
  computed: {
    formTitle() {
      if (this.editedIndex === -1) {
        return `Nouvelle ${this.subject}`;
      }
      const item = this.objectsGeoJson[this.editedIndex];
      return `Edition ${this.subject} id:${item.id}`;
    },
    computedHeaders() {
      return this.headers.filter((h) => !h.hide || !this.$vuetify.breakpoint[h.hide]);
    },
  },
  filters: {
    convertTextEnt(text) {
      return convertEnt(text);
    },
    timestampDateIso2Europe(isoDate) {
      if (isNullOrUndefined(isoDate)) return '';
      return dateIso2Fr(isoDate.split('T')[0]);
    },
    limitTextSize(text, maxSize = 40) {
      if (isNullOrUndefined(text)) return '';
      if (text.length < maxSize) return text;
      return `${text.substring(0, maxSize)}…`;
    },
  },

  watch: {
  },

  methods: {
    checkEditPermissions(item) {
      if (isUserHavingLimitedCategories()) {
        // SI OBJET CID OU RM ET QUE USER CID OU RM ON MONTRE UNIQUEMENT CAR PAS EDITION
        if (getUserLimitedCategoriesArray().indexOf(item.properties.idcategorie) > -1) {
          return false;
        }
      }
      if (item.properties.isvalidated === null) {
        if (this.idUser === item.properties.creator || this.isUserAdmin || this.isUserValidator) {
          return true;
        }
      }
      return false;
    },
    checkValidatePermissions(item) {
      if (isUserHavingLimitedCategories()) {
        // SI OBJET CID OU RM ET QUE USER CID OU RM  LAISSE VALIDER
        if (getUserLimitedCategoriesArray().indexOf(item.properties.idcategorie) > -1) {
          if (this.isUserValidator && item.properties.isvalidated === null) {
            return true;
          }
        }
      } else if (item.properties.isvalidated === null) {
        const categoryName = this.getCategoryName(item.properties.idcategorie);
        if (this.isUserValidator && !categoryName.startsWith('RM')) {
          return true;
        }
      }
      return false;
    },
    checkTerminatePermissions(item) {
      if (item.properties.isvalidated !== null) {
        if (item.properties.idcategorie === 8) {
          // les afaires pigeons sont terminees dans goeland
          return false;
        }
        if (isUserHavingLimitedCategories()) {
          // SI OBJET CID OU RM ET QUE USER CID OU RM  LAISSE VALIDER
          if (getUserLimitedCategoriesArray().indexOf(item.properties.idcategorie) > -1) {
            if (this.isUserValidator) {
              return true;
            }
          }
        } else if (item.properties.idcategorie > 1 && item.properties.idcategorie < 1001) {
          const categoryName = this.getCategoryName(item.properties.idcategorie);
          if (this.isUserValidator && !categoryName.startsWith('RM')) {
            return true;
          }
        }
      }
      return false;
    },
    getCategoryName(idCategorie) {
      const c = this.categories.find((x) => x.id === idCategorie);
      return c.name;
    },
    newItem() {
      log.t('# in newItem');
      this.$emit('managerNewItem', this.editedItem);
    },
    editItem(item) {
      log.t('# in editItem');
      this.$emit('managerEditItem', item);
    },
    showItem(item) {
      log.t('# in editItem');
      this.$emit('managerShowItem', item);
    },
    validateItem(item) {
      log.t('# in validateItem');
      this.$emit('managerValidateItem', item);
    },
    unValidateItem(item) {
      log.t('# in unValidateItem');
      this.$emit('managerUnValidateItem', item);
    },
    terminateItem(item) {
      log.t('# in validateItem');
      this.$emit('managerTerminateItem', item);
    },
    deleteItem(item) {
      log.t('# in deleteItem');
      this.$emit('managerDeleteItem', item);
    },
    handleClickItemRow(item) {
      log.t('# in deleteItem');
      this.$emit('managerClickItem', item);
    },

  }, // end of methods
};
</script>
